/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { Col, Row } from "react-awesome-styled-grid";
import { Box } from "@nordcloud/gnui";
import { BreadcrumbsBox } from "~/components/BreadcrumbsBox";
import { ROUTES } from "~/routing/routes";
import { AuditLogsTable } from "./components";

const breadcrumbsLabels = [
  { label: "Dashboard", uri: "/" },
  { label: "Audit Logs", uri: ROUTES.auditLogs.index },
];

export function AuditLogsPage() {
  return (
    <>
      <Row>
        <Col>
          <BreadcrumbsBox
            title="Audit Logs"
            customBreadcrumbs={breadcrumbsLabels}
          />
        </Col>
      </Row>
      <Row>
        <Col>
          <Box>
            <AuditLogsTable />
          </Box>
        </Col>
      </Row>
    </>
  );
}
